import { apiProvider } from "./utilities/provider";
import { JsonDocument } from "./utilities/json";

export type AdminSupportArticle = {
  id: number;
  createdAt?: string;
  updatedAt?: string;
  supportCategoryId: number;
  title: string;
  slug: string;
  content: string;
  sortOrder: number;
  published: boolean;
  archivedAt?: string | null;
};

export type AdminSupportCategory = {
  id: number;
  createdAt?: string;
  updatedAt?: string;
  name: string;
  slug: string;
  sortOrder: number;
  articles: AdminSupportArticle[];
  archivedAt?: string | null;
};

export type AdminSupportCategoryInput = {
  name: string;
  slug: string;
  sortOrder: number;
};

export type AdminSupportArticleInput = {
  supportCategoryId: number;
  title: string;
  slug: string;
  content: string;
  sortOrder: number;
  published: boolean;
};

export const adminSupportContentApi = {
  getAll: (): Promise<AdminSupportCategory[]> =>
    apiProvider
      .getAll("admin/support-content")
      .then((d: JsonDocument<AdminSupportCategory[]>) => d.data),

  createCategory: (
    data: AdminSupportCategoryInput,
  ): Promise<AdminSupportCategory> =>
    apiProvider
      .post("admin/support-categories", {
        data,
      })
      .then((d: JsonDocument<AdminSupportCategory>) => d.data),

  updateCategory: (
    id: number,
    data: AdminSupportCategoryInput,
  ): Promise<AdminSupportCategory> =>
    apiProvider
      .put("admin/support-categories", id, {
        data,
      })
      .then((d: JsonDocument<AdminSupportCategory>) => d.data),

  archiveCategory: (id: number): Promise<AdminSupportCategory> =>
    apiProvider
      .remove("admin/support-categories", id)
      .then((d: JsonDocument<AdminSupportCategory>) => d.data),

  createArticle: (
    data: AdminSupportArticleInput,
  ): Promise<AdminSupportArticle> =>
    apiProvider
      .post("admin/support-articles", {
        data,
      })
      .then((d: JsonDocument<AdminSupportArticle>) => d.data),

  updateArticle: (
    id: number,
    data: AdminSupportArticleInput,
  ): Promise<AdminSupportArticle> =>
    apiProvider
      .put("admin/support-articles", id, {
        data,
      })
      .then((d: JsonDocument<AdminSupportArticle>) => d.data),

  archiveArticle: (id: number): Promise<AdminSupportArticle> =>
    apiProvider
      .remove("admin/support-articles", id)
      .then((d: JsonDocument<AdminSupportArticle>) => d.data),
};
